import { createEffect, createEvent, createStore, sample } from 'effector'
import { googlePalFeatureModel } from '~/features/google-pal'
import { random } from '~/shared/helpers'

/* 
   Watch ID - A unique identifier for a single view.
   Send requestRandom header value generated by the client application each time it 
   requests a playback URL from the backend . 
   See https://setplexapps.atlassian.net/wiki/spaces/OVP/pages/2799239384/ad-client-params+header 
*/
export const generateWatchIdFx = createEffect(() => {
  return random(1, 99999999)
})
const generateWatchId = createEvent<void>()
export const $watchId = createStore<number | null>(null).on(
  generateWatchIdFx.doneData,
  (_, data) => data
)

sample({
  clock: generateWatchId,
  target: generateWatchIdFx,
})

// Generate watchId if all google pal effects already resolved (failed or done).
// If google pal effects failed (ad block) googlePalFeatureModel.$idType will be responsible for trigerring generateWatchId
// after generating watchId we trigger doRequest (load url) in the target models
sample({
  clock: [
    googlePalFeatureModel.$waitingForNonce,
    googlePalFeatureModel.$idType,
  ],
  source: {
    waitingForNonce: googlePalFeatureModel.$waitingForNonce,
  },
  filter: ({ waitingForNonce }) => !waitingForNonce,
  target: generateWatchId,
})
